// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"921":"75265f26","984":"88ec9933"}[chunkId] + ".css";
};